import React, { Component } from "react";
import { connect } from "react-redux";
import queryString from "query-string";
import { createSelector } from "reselect";
import { isEmpty } from "lodash";
import { Redirect } from "react-router-dom";

import { getDisplayName, bindDispatch } from "../../../../utils";
import { validateMandatoryCampaignFields } from "../utils/campaignCreate";
import PageLoadingWithTabs from "../../../common/PageLoadingWithTabs";
import { CAMPAIGN_ACTIONS_ALLOWED_STATUS_LIST, CAMPAIGN_ACTIONS } from "../../../../constants";
import EmptyPage from "../../../common/EmptyPage";

export const campaignRouteHandler = (ChildComponent) => {
  class CampaignRouteHandler extends Component {
    isUnmounted = false;

    state = {
      isCampaignValid: false,
      hasTargetGroups: false,
      hasMediaList: false,
      isFetching: true,
    };
    componentDidMount = async () => {
      const {
        actions,
        history,
        match: { params, path },
      } = this.props;
      const query = queryString.parse(history.location.search);
      const requestParams = { ps: 50, ...params, ...query };
      await actions.getNewCampaignDetails(params);
      if (params.campaignId) {
        const isReviewRoute = path.includes("review") || path.includes("finish");
        if (isReviewRoute || path.includes("target-groups") || path.includes("media")) {
          await actions.getNewCampaignTargetGroups(requestParams);
        }
        if (isReviewRoute || path.includes("media")) {
          await actions.getNewCampaignMediaList(requestParams);
        }

        if (path.includes("target-groups" || true)) {
          if (!isEmpty(params.action) && params.action !== "list")
            this.handleFetchAction(params, actions.getTargetGroupById, query?.id);
        }
        if (path.includes("media")) {
          if (!isEmpty(params.action) && params.action !== "list")
            this.handleFetchAction(params, actions.getMediaById, query?.id);
        }
      }

      if (!this.isUnmounted) {
        this.setState({
          isFetching: false,
        });
      }
    };
    componentWillUnmount() {
      this.isUnmounted = true;
      this.props.actions.resetCampaignCreateError();
    }

    handleFetchAction = async (params, fetchAction, id) => {
      if (params.action === "create" && id) {
        await fetchAction(id, "duplicate");
      } else if (params.action !== "create") {
        await fetchAction(params.action, "edit");
      }
    };

    handleComponentRedirect = (url) => {
      const {
        location: { pathname },
      } = this.props;

      if (pathname !== url) return <Redirect replace to={url} />;

      return <ChildComponent {...this.props} />;
    };

    handleReviewAndProposalRoutes = (url) => {
      const {
        match: {
          params: { campaignId },
        },
        campaignCreate: { campaign, campaignTargetGroups, campaignMediaList },
      } = this.props;
      const isCampaignValid = campaignId && !isEmpty(campaign);
      const hasTargetGroups =
        (campaignTargetGroups?.totalUnfilteredCount ??
          campaignTargetGroups?.totalCount ??
          campaignTargetGroups?.data?.length ??
          0) > 0;
      const hasMediaList =
        (campaignMediaList?.totalUnfilteredCount ??
          campaignMediaList?.totalCount ??
          campaignMediaList?.data?.length ??
          0) > 0;
      if (isCampaignValid) {
        if (hasTargetGroups) {
          if (hasMediaList) {
            return <ChildComponent {...this.props} />;
          } else {
            return this.handleComponentRedirect(`/campaign-create/${campaignId}/media/create`);
          }
        } else {
          return this.handleComponentRedirect(
            `/campaign-create/${campaignId}/target-groups/create`
          );
        }
      } else {
        return this.handleComponentRedirect(`/campaign-create/${campaignId}/details`);
      }
    };

    handleMediaRoutes = () => {
      const {
        match: {
          params: { campaignId, action },
        },
        campaignCreate: { campaign },
      } = this.props;
      if (isEmpty(campaign))
        return <ChildComponent {...this.props} isCampaignInvalid={isEmpty(campaign)} />;

      //if no action then redirect to List Page
      if (isEmpty(action)) {
        // if (hasMediaList) {
        return this.handleComponentRedirect(`/campaign-create/${campaignId}/media/list`);
        // } else return this.handleComponentRedirect(`/campaign-create/${campaignId}/media/create`);
      }

      // if (action === "list" && !hasMediaList)
      //   return this.handleComponentRedirect(`/campaign-create/${campaignId}/media/create`);

      return <ChildComponent {...this.props} isCampaignInvalid={isEmpty(campaign)} />;
    };

    handleTargetGroupRoutes = () => {
      const {
        match: {
          params: { campaignId, action },
        },
        campaignCreate: { campaign },
      } = this.props;

      if (isEmpty(campaign)) return <ChildComponent {...this.props} isCampaignInvalid />;

      //if no action then redirect to List Page
      if (isEmpty(action)) {
        // if (hasTargetGroups) {
        return this.handleComponentRedirect(`/campaign-create/${campaignId}/target-groups/list`);
        // } else {
        //   return this.handleComponentRedirect(
        //     `/campaign-create/${campaignId}/target-groups/create`
        //   );
        // }
      }

      // if (action === "list" && !hasTargetGroups)
      //   return this.handleComponentRedirect(`/campaign-create/${campaignId}/target-groups/create`);

      return <ChildComponent {...this.props} isCampaignInvalid={isEmpty(campaign)} />;
    };

    render() {
      const { isFetching } = this.state;
      const {
        match: {
          params: { campaignId },
          url,
        },
        campaignCreate: { campaign },
      } = this.props;
      // const { url } = this.state;
      const isCampaignValid = campaignId && validateMandatoryCampaignFields(campaign);

      // Loading and Error States
      if (isFetching) return <PageLoadingWithTabs />;
      // Campaign Routes
      if (!campaignId) return this.handleComponentRedirect(`/campaign-create`);
      if (campaignId) {
        if (!CAMPAIGN_ACTIONS_ALLOWED_STATUS_LIST[CAMPAIGN_ACTIONS.EDIT].includes(campaign?.status))
          return (
            <EmptyPage
              heading="EmptyState.campaignNotEditableHeading"
              body="EmptyState.campaignNotEditableMessage"
              isHomeLinkVisible
            />
          );
        // Target Group
        if (url.includes("target-groups")) return this.handleTargetGroupRoutes();

        // Media
        if (url.includes("media")) return this.handleMediaRoutes();

        // Review And Finish
        if (url.includes("review") || url.includes("finish")) {
          return this.handleReviewAndProposalRoutes();
        }

        if (!isEmpty(campaign) && (!isCampaignValid || !url.includes("details"))) {
          return this.handleComponentRedirect(`/campaign-create/${campaignId}/details`);
        }

        return <ChildComponent {...this.props} isCampaignInvalid={isEmpty(campaign)} />;
      }
    }
  }

  CampaignRouteHandler.displayName = `CampaignRouteHandler(${getDisplayName(ChildComponent)})`;

  const mapStateToProps = createSelector(
    (state) => state.campaignCreate,
    (campaignCreate) => ({
      campaignCreate,
    })
  );

  return connect(mapStateToProps, bindDispatch)(CampaignRouteHandler);
};

export default campaignRouteHandler;
